import React from 'react';
import { Controller } from 'react-hook-form';
import { ClipLoader } from 'react-spinners';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { Checkbox } from '@mui/material';
import { customersCount, weekDays } from '../../../../../../../Costants/costants';
import useBusinessMainProfileHooks from './profileMain-hook';
import { useGeneralHooks } from '../../../../../../../Hooks/hooks';
import { ICompanyResponse } from '../../../../../../../Interfaces/responseTypes';
import { ButtonTypes } from '../../../../../../../Interfaces/componentTypes';
import FileUploader from '../../../../../../../Components/FileUploader/fileUploader';
import AuthInput from '../../../../../../../Components/Inputs/AuthInput/authInput';
import AutoComplete from '../../../../../../../Components/Inputs/AutoComplete/autoComplete';
import MultiSelectAutoComplete from '../../../../../../../Components/Inputs/MultipleAutocomplete/multipleAutoComplete';
import CustomTimePicker from '../../../../../../../Components/Inputs/TimePicker/timePicker';
import Button from '../../../../../../../Components/Button/button';
import styles from './profileMain.module.scss';

export interface IEditBusinessProfileMainProps {
  data: ICompanyResponse;
  onUpdate: () => void
};

const ProfileMainInfo: React.FC<IEditBusinessProfileMainProps> = (props) => {
  const { t, baseURL } = useGeneralHooks();
  const {
    is24,
    errors,
    control,
    country,
    imageUrl,
    isLoading,
    validated,
    isProfile,
    isFullWeek,
    imageLoading,
    onEdit,
    setValue,
    register,
    handle24,
    setCountry,
    hanedleFullWeek,
    handleFileInputChange,
  } = useBusinessMainProfileHooks(props)

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p>
          {t('My_Business.Business_Profile.Main.Header')}
        </p>
      </div>
      <div className={styles.form}>
        <div className={styles.itemBox}>
          <div className={styles.item}>
            <div className={styles.label}>
              <p>{t('Business.Step_3.Title')}</p>
            </div>
            <div className={styles.uploadBox}>
              <div className={styles.imageBox}>
                {
                  imageLoading
                    ?
                    <ClipLoader color="#aa002b" size={40} />
                    :
                    <img
                      src={imageUrl ?? `${baseURL}${props.data.logo}`}
                      alt={`${imageUrl}.png`}
                      className={styles.image}
                    />
                }
              </div>
              <div className={styles.fileUploderBox}>
                <FileUploader
                  id='logo'
                  handleFileInputChange={handleFileInputChange}
                  buttonTitleStyle={styles.buttonTitle}
                  buttonStyle={`${styles.uploadButton}`}
                />
              </div>
            </div>
          </div>

          <div className={styles.inputBox}>
            <div className={styles.item}>
              <div className={styles.label}>
                <p>
                  {t('Business.Title')}
                </p>
              </div>
              <AuthInput
                register={register}
                registerName='name'
                labelStyle={styles.inputLabel}
                error={errors.name}
                patternValue={/.*[A-Za-zÀ-ÖØ-öø-ÿԱ-Ֆա-ֆА-Яа-яҐґЄєІіЇїΆ-ώΑ-ωא-ת一-龯ぁ-ゔァ-ヾㄱ-ㅎㅏ-ㅣ가-힣].*/}
              />
            </div>
            <Controller
              name="country"
              rules={{
                required: t('Errors.Required'),
              }}
              render={({ field: { name, onChange, value } }) => (
                <div className={styles.item}>
                  <div className={styles.label}>
                    <p>
                      {t('Business.Country')}
                    </p>
                  </div>
                  <CountryDropdown
                    defaultOptionLabel="Select Country"
                    name={name}
                    value={value}
                    onChange={(value) => {
                      onChange(value)
                      setCountry(value)

                    }}
                    valueType='full'
                  />
                </div>
              )}
              control={control}
            />
          </div>
        </div>
        <div className={styles.itemBox}>
          <div className={styles.inputBox}>

            <Controller
              name="city"
              rules={{
                required: t('Errors.Required'),
              }}
              render={({ field: { name, onChange, value } }) => (
                <div className={styles.item}>
                  <div className={styles.label}>
                    <p>
                      {t('Business.City')}
                    </p>
                  </div>
                  <RegionDropdown
                    country={country!}
                    disableWhenEmpty
                    defaultOptionLabel={t('Business.City_Plh')}
                    name={name}
                    value={value}
                    onChange={onChange}
                    valueType='full'
                  />
                </div>
              )}
              control={control}
            />
            <div className={styles.item}>
              <div className={styles.label}>
                <p>
                  {t('Business.Address')}
                </p>
              </div>
              <AuthInput
                register={register}
                registerName='address'
                labelStyle={styles.inputLabel}
                error={errors.address}
                patternValue={/.*[A-Za-zÀ-ÖØ-öø-ÿԱ-Ֆա-ֆА-Яа-яҐґЄєІіЇїΆ-ώΑ-ωא-ת一-龯ぁ-ゔァ-ヾㄱ-ㅎㅏ-ㅣ가-힣].*/}
              />
            </div>
          </div>

          <div className={styles.inputBox}>
            <div className={styles.inputBox} style={{ gap: "0" }}>
              <Controller
                control={control}
                name='free_days'
                rules={{
                  required: !isFullWeek
                }}
                render={({ field: { onChange, name, value } }) => {
                  return (
                    <div className={styles.item}>
                      <div className={`${styles.label} ${styles.autocomplete}`}>
                        <p>
                          {t('Business.Free')}
                        </p>
                      </div>
                      <MultiSelectAutoComplete
                        value={value}
                        name={name}
                        onChange={(value) => {
                          onChange(value)
                          setValue('free_days', value!)
                        }}

                        data={weekDays}
                      />
                    </div>
                  );
                }}
              />

              <div className={styles.checkBoxRow}>
                <Checkbox
                  checked={isFullWeek}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => {
                    hanedleFullWeek(e)

                  }}
                  sx={{
                    color: '#505053',
                  }}
                  size="medium"
                />
                <p>{t('Business.Full_Week')}</p>
              </div>
            </div>
            <div className={styles.timePickerContainer}>
              <div className={styles.label}>
                <p>
                  {t('Business.Working_Hours')}
                </p>
              </div>
              <div className={styles.timePickerBox}>
                <Controller
                  name="start_time"
                  control={control}
                  render={({ field }) => (
                    <CustomTimePicker
                      value={field.value}
                      onChange={field.onChange}
                      style={styles.timePicker}
                      error={errors.start_time}
                      placeholder={t('Business.Start')}
                    />
                  )}
                />
                <Controller
                  name="end_time"
                  control={control}
                  render={({ field, fieldState }) => (
                    <CustomTimePicker
                      value={field.value}
                      onChange={field.onChange}
                      style={styles.timePicker}
                      error={errors.end_time}
                      placeholder={t('Business.End')}
                    />
                  )}
                />

              </div>
              <div className={styles.checkBoxRow}>
                <Checkbox
                  checked={is24}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => {
                    handle24(e)

                  }}
                  sx={{
                    color: '#505053',
                  }}
                  size="medium"
                />
                <p>{t('Business.Round_Clock')}</p>
              </div>
            </div>
          </div>
        </div>
        {
          validated
          &&
          <Button
            buttonType={ButtonTypes.Primery}
            onClick={onEdit}
            title={isProfile ? t('Buttons.Save') : t('Buttons.Activate_Profile')}
            buttonStyle={styles.button}
            buttonTitleStyle={!isProfile ? styles.buttonTitle : undefined}
            isLoading={isLoading}
          />
        }
      </div>
    </div>
  )
}

export default ProfileMainInfo
